import { get } from './nodash';
const mapOrder =
  (order = [], key) =>
  (a, b) =>
    order.indexOf(get(key, a)) > order.indexOf(get(key, b)) ? 1 : -1;

export default mapOrder;
